import { render, staticRenderFns } from "./addpurchase.vue?vue&type=template&id=641d04d8&scoped=true"
import script from "./addpurchase.vue?vue&type=script&lang=js"
export * from "./addpurchase.vue?vue&type=script&lang=js"
import style0 from "./addpurchase.vue?vue&type=style&index=0&id=641d04d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641d04d8",
  null
  
)

export default component.exports